/**
 * The board's editor filter, carried in the URL.
 *
 * Keeping it in the query string is what lets the detail screen hand back a complete
 * board URL, so Editor -> Project -> Back returns to that editor's project list.
 *
 * `unassigned=true` predates this and is kept as its own flag so existing links
 * (and the overdue/unassigned shortcuts) keep working; a real editor is `editor=<id>`.
 */

/** The editor filter value held in a URLSearchParams, as the Select expects it. */
export const readEditorParam = (params) => {
  if (!params) return '';
  if (params.get('unassigned') === 'true') return 'unassigned';
  return params.get('editor') || '';
};

/**
 * Return a new URLSearchParams with the editor filter set to `value`.
 * '' clears it, 'unassigned' sets the legacy flag, anything else is an editor id.
 * The two are mutually exclusive, so setting either clears the other.
 */
export const writeEditorParam = (prevParams, value) => {
  const next = new URLSearchParams(prevParams || undefined);
  if (value === 'unassigned') {
    next.set('unassigned', 'true');
    next.delete('editor');
  } else if (value) {
    next.set('editor', String(value));
    next.delete('unassigned');
  } else {
    next.delete('unassigned');
    next.delete('editor');
  }
  return next;
};
